export default __webpack_public_path__ + "static/media/102.2192e456.jpg";